import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { hiddenRoutes } from 'src/app/layout/data/vt-route-list';
import { GlobalUser } from 'src/app/layout/model/global-user';
import { CurrentUserService } from 'src/app/pages/authentication/service/current-user.service';

@Component({
  selector: 'prep-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  @Input() current: string;
  @Input() crumbs: any[] = [];
  hideSidebarNavigation = true;
  account: GlobalUser = new GlobalUser();
  constructor(private router: Router, private currentUserService: CurrentUserService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.hideSidebarNavigation = hiddenRoutes.some(route =>
          event.urlAfterRedirects.includes(route)
        );
      }
    });
  }

  ngOnInit() {
    this.currentUserService.GetCurrentUser().subscribe(
      (response) => {
        this.account = response;
      });
  }

  // Prevent navigation when the user activates the current-page link.
  // The aria-current="page" + focusable role=link is what AT and
  // keyboard users need; reloading the same route would be user-hostile.
  onCurrentClick(event: Event): void {
    event.preventDefault();
  }

}
